module.exports = "data:image/gif;base64,R0lGODlhFQAQAJEAAO7u7szMzO7u7gAAACH5BAEAAAIALAAAAAAVABAAQAIglI+py8F/HHxy2huxqst58XHaFIKmmKCYerGWS44yUgAAOw=="